import Combo, { ComboProps } from 'app/components/ui/combo/combo'
import FormInputWrapper from './FormInputWrapper'
import { OptionType } from 'types/OptionType'

export type FormComboComponentProps = ComboProps & {
  name: string
  label?: string
  cols?: 1 | 2 | 3 | 4 | 5 | 6
  wrapperClassName?: string
  labelClassName?: string
  inputClassName?: string
  newLineError?: boolean
  showErrorIcon?: boolean
  required?: boolean
  error: string | undefined
  value: OptionType | undefined
  onChangeHandler: (option: OptionType) => void
  infoTooltip?: { title: string; message: string }
}

export function FormComboComponent({
  name,
  label,
  cols,
  wrapperClassName,
  labelClassName,
  inputClassName,
  newLineError,
  showErrorIcon,
  error,
  onChangeHandler,
  required,
  ...props
}: FormComboComponentProps) {
  return (
    <FormInputWrapper
      {...{
        name,
        label,
        error,
        newLineError,
        showErrorIcon,
        cols,
        wrapperClassName,
        className: labelClassName,
        infoTooltip: props.infoTooltip,
      }}
    >
      <Combo {...props} name={name} inputClassName={inputClassName} onChange={onChangeHandler} />
    </FormInputWrapper>
  )
}
